import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { withLang } from "./withLang";

export const groupsApi = createApi({
  reducerPath: "groupsApi",
  baseQuery: withLang(
    fetchBaseQuery({
      baseUrl: `${process.env.REACT_APP_API_BASE_URL}/apiv2/`,
    }),
  ),
  endpoints: (builder) => ({
    activityFeedPlayerToken: builder.mutation({
      query: (body) => ({
        url: `getstream/user`,
        method: "POST",
        body: body,
      }),
    }),
    activityFeedOrganizerToken: builder.mutation({
      query: (body) => ({
        url: `getstream/organizer`,
        method: "POST",
        body: body,
      }),
    }),
    createFeedGroup: builder.mutation({
      query: (body) => ({
        url: `getstream/feed-group`,
        method: "POST",
        body: body,
      }),
    }),
    getTournamentInfo: builder.mutation({
      query: (body) => ({
        url: `getstream/info`,
        method: "POST",
        body: body,
      }),
    }),
    searchUsers: builder.query({
      query: ({ q, u, feedType, feedId, permission }) => ({
        url: `getstream/search`,
        method: "GET",
        params: { q, u, feedType, feedId, permission },
      }),
    }),
    getFollowers: builder.query({
      query: ({ u, feedType, feedId, permission }) => ({
        url: `getstream/followers`,
        method: "GET",
        params: { u, feedType, feedId, permission },
      }),
    }),
    updateGetstreamUser: builder.mutation({
      query: (body) => ({
        url: `getstream/update-user`,
        method: "POST",
        body: body,
      }),
    }),
    updateGetstreamOrganizer: builder.mutation({
      query: (body) => ({
        url: `getstream/update-organizer`,
        method: "POST",
        body: body,
      }),
    }),
    checkFeedPermissions: builder.mutation({
      query: (body) => ({
        url: `getstream/permissions`,
        method: "POST",
        body: body,
      }),
    }),
    getAvailableGroups: builder.mutation({
      query: (body) => ({
        url: `getstream/groups/available`,
        method: "POST",
        body: body,
      }),
    }),
    getOrganizerGroups: builder.mutation({
      query: (body) => ({
        url: `getstream/groups/organizer`,
        method: "POST",
        body: body,
      }),
    }),
  }),
});

export const {
  useActivityFeedPlayerTokenMutation,
  useActivityFeedOrganizerTokenMutation,
  useCreateFeedGroupMutation,
  useGetTournamentInfoMutation,
  useLazySearchUsersQuery,
  useUpdateGetstreamUserMutation,
  useUpdateGetstreamOrganizerMutation,
  useCheckFeedPermissionsMutation,
  useGetAvailableGroupsMutation,
  useGetOrganizerGroupsMutation,
  useGetFollowersQuery,
  useLazyGetFollowersQuery,
} = groupsApi;

    